import { localStorageAdapter } from './storage';
export const STORAGE_KEY = '__trackingOptInStatus';
export const SCRIPT_NAME = '__toi';
export var OPTIN_STATUS;
(function (OPTIN_STATUS) {
    /** Consent has not yet been given or has been reset */
    OPTIN_STATUS[OPTIN_STATUS["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /** Consent has been granted */
    OPTIN_STATUS[OPTIN_STATUS["GRANTED"] = 1] = "GRANTED";
    /** Consent has been denied */
    OPTIN_STATUS[OPTIN_STATUS["DENIED"] = -1] = "DENIED";
})(OPTIN_STATUS || (OPTIN_STATUS = {}));
/** Wrapper to export a mutable object */
export const storageAdapter = {
    instance: localStorageAdapter(),
};
/** Retrieves the current configuration from the storage adapter */
export const loadConfiguration = () => JSON.parse(storageAdapter.instance.get(STORAGE_KEY) || '{}') || {};
/**
 * @param serviceId ID of a {@link TrackingOptInService}
 * @returns The consent status for this service or
 *      {@link OPTIN_STATUS.UNSPECIFIED} if not yet specified.
 */
export const getServiceStatus = (serviceId) => loadConfiguration()[serviceId] || OPTIN_STATUS.UNSPECIFIED;
